module.exports = __webpack_public_path__ + "img/antes_despues_215.f07f49e7.png";